import { useMemo } from "react";

import useMainNavigationPrimaryItems from "./usePrimaryItems";
import useMainNavigationSecondaryItems from "./useSecondaryItems";

const useMainNavigationAllItems = () => {
  const { menuItemsMap: primaryMenuItemsMap, navigationItems: primaryNavigationItems } =
    useMainNavigationPrimaryItems();
  const { menuItemsMap: secondaryMenuItemsMap, navigationItems: secondaryNavigationItems } =
    useMainNavigationSecondaryItems();

  return useMemo(() => {
    const allMenuItemsMap = { ...primaryMenuItemsMap, ...secondaryMenuItemsMap };

    return {
      allMenuItems: Object.values(allMenuItemsMap),
      allMenuItemsMap,
      allNavigationItems: [...primaryNavigationItems, ...secondaryNavigationItems],
    };
  }, [
    primaryMenuItemsMap,
    secondaryMenuItemsMap,
    primaryNavigationItems,
    secondaryNavigationItems,
  ]);
};

export default useMainNavigationAllItems;
